export interface IPriceByCatEntry {
	price: {
		offerPrice: string;
		taxablePrice: string;
		comParamInstallmentPeriod: string;
		vatValue: string;
		comParamInstallmentValue: string;
		vatPercent: string;
		listPrice: string;
	};
}

const model: types.models.InputModel = {
	price: ['response.price', []],
};

export default model;
